import { _Base } from "./_base";

export class Entry extends _Base {
    eventId: string;
    start: any;
    finish: any;
    referees?: string[];
    lane: string;

    time(){
        return this.finish && this.start ? this.timeFormat(this.finish-this.start) : null;
    }
    private timeFormat(time){
        const second = 1;
        const minute = 60*second;
        const hour = 60*minute;

        let remainder = time;
        const hours = Math.floor(remainder/hour);
        remainder -= hour*hours;
        const minutes = Math.floor(remainder/minute);
        const seconds = remainder - minute*minutes;

        let string = hours ? `${('00'+hours).slice(-2)}:` : '';
        return string + `${('00'+minutes).slice(-2)}:${('00'+seconds.toFixed(3)).slice(-6)}`
    }
}